module.exports = __webpack_public_path__ + "static/media/landing1.0e6e9ec8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/landing1.jpg
// module id = 311
// module chunks = 0